// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"77e569db","656":"44320ed8","736":"155acfb6"}[chunkId] + ".css";
};